import React from "react"
import { injectIntl } from "react-intl"
import BaseNoResult from "../../common/no-result/BaseNoResult"
import IntlProps from "../../state/helpers/IntlProps"
import { messages } from "./messages"

const NoTerminals = (props: IntlProps) => {
    return  (
        <BaseNoResult 
            title={props.intl.formatMessage(messages.noTerminalsHeader)}
            description={props.intl.formatMessage(messages.noTerminalsBody)}
            displayImage={true}
            image={<img src='/images/Payment-2.svg' width="80px" alt="Terminal" />}
        />
    )
}

export default injectIntl(NoTerminals)


// WEBPACK FOOTER //
// ./src/payment-processing/terminal-listing/NoTerminals.tsx